/* import __COLOCATED_TEMPLATE__ from './editor.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';
import type PhoneOneTimePasscode from 'embercom/models/operator/visual-builder/step/phone-one-time-passcode';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';

interface Signature {
  Args: {
    step: PhoneOneTimePasscode;
    isReadOnly: boolean;
    editorState: EditorState;
    className?: string;
  };
  Element: HTMLDivElement;
}

const PhoneOneTimePasscodeEditor = templateOnlyComponent<Signature>();
export default PhoneOneTimePasscodeEditor;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::PhoneOneTimePasscode::Editor': typeof PhoneOneTimePasscodeEditor;
    'workflows/graph-editor/node-items/steps/phone-one-time-passcode/editor': typeof PhoneOneTimePasscodeEditor;
  }
}
